import { makeStyles } from '@material-ui/core/styles';
import { colors } from 'theme/color-palette';
const {
	PURPLE,
	WHITE,
	LIGHT_GREY,
	GREY,
	HOVER_GRAY_SHADE,
	FONT_COLOR,
	DARK_PURPLE,
	TOGGLE_ACTIVE
} = colors;
import { Bogle_Regular, Bogle_Medium } from 'constants/constant';

const quickReportStyle = makeStyles(() => ({
	buttonContainer: {
		textAlign: 'center',
		padding: '16px',
		paddingRight: '32px',
		borderTop: `1px solid ${LIGHT_GREY}`,
		position: 'fixed',
		bottom: 0,
		zIndex: 999,
		width: '328px',
		background: WHITE,
		'&:hover': {
			background: TOGGLE_ACTIVE,
			color: PURPLE
		}
		// maxHeight: 88
	},
	drawerContainer: {
		width: '360px',
		overflow: 'auto'
	},
	titleFont: {
		fontSize: '20px',
		fontFamily: Bogle_Regular,
		fontWeight: 300,
		height: '70px',
		display: 'flex',
		alignItems: 'center',
		paddingLeft: (P) => (P.isSmallScreen ? '44px' : '16px'),
		marginLeft: '24px'
	},
	titleFontOnly: {
		fontSize: '20px',
		fontFamily: Bogle_Regular,
		fontWeight: 700,
		height: '70px',
		display: 'flex',
		alignItems: 'center',
		paddingLeft: (P) => (P.isSmallScreen ? '44px' : '16px')
	},
	titleText: {
		textOverflow: 'ellipsis',
		textTransform: 'capitalize',
		overflow: 'hidden',
		whiteSpace: 'nowrap',
		maxWidth: '220px'
	},
	tooltipCapitalize: {
		textTransform: 'capitalize'
	},
	content: {
		height: `calc(100vh - 270px)`
	},
	titleContainer: {
		position: 'relative',
		borderBottom: `1px solid ${LIGHT_GREY}`
	},
	titleWrapper: { display: 'flex', height: '70px', alignItems: 'center' },
	hugeTitleWrapper: { display: 'flex', height: '144px', alignItems: 'center' },
	filterList: { display: 'flex', alignItems: 'center', marginTop: '2px' },
	backButton: {
		position: 'absolute',
		top: 0,
		left: 0,
		color: GREY,
		marginTop: '16px',
		height: 40,
		width: 40
	},
	arrow: {
		'&:before': {
			border: `1px solid ${LIGHT_GREY}`
		},
		color: WHITE
	},
	addIcon: {
		border: `1px solid ${PURPLE}`,
		borderStyle: 'dashed',
		padding: '13px',
		borderRadius: '8px',
		color: PURPLE
	},
	scratch: {
		display: 'flex',
		alignItems: 'center',
		fontSize: '18px',
		cursor: 'pointer'
	},
	previewBtnContainer: {
		textAlign: 'center',
		padding: '16px',
		borderTop: `1px solid ${LIGHT_GREY}`,
		position: 'fixed',
		bottom: 0,
		zIndex: 999,
		width: '328px',
		background: WHITE
	},
	disabledLinkWrapper: {
		padding: 'unset!important'
	},
	subTemplates: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		fontSize: '16px',
		cursor: 'pointer',
		padding: '24px 16px',
		'&:hover': {
			backgroundColor: HOVER_GRAY_SHADE
		}
	},
	noTemplateMsg: {
		padding: '24px 16px',
		fontSize: '14px',
		color: GREY
	},
	noTempMsgOne: {
		paddingBottom: 24
	},
	normalFont: {
		marginLeft: '16px',
		fontWeight: '700',
		color: PURPLE
	},
	highlightedFont: {
		color: PURPLE,
		fontFamily: 'Bogle-Medium'
	},
	rightArrow: {
		padding: '8px 8px 8px 8px'
	},
	submitButton: {
		color: `${WHITE} !important`,
		background: PURPLE,
		marginBottom: '8px',
		'&:hover': {
			color: `${WHITE} !important`,
			background: `${DARK_PURPLE} !important`
		}
	},
	cancelButton: {
		color: PURPLE,
		background: WHITE,
		'&:hover': {
			color: `${PURPLE} !important`,
			background: TOGGLE_ACTIVE
		}
	},
	subHeader: {
		paddingLeft: '16px',
		position: 'relative',
		display: 'flex',
		alignItems: 'center',
		height: '32px'
	},
	subHeaderText: {
		textTransform: 'capitalize',
		fontSize: '14px',
		fontFamily: Bogle_Medium,
		display: 'flex',
		alignItems: 'center',
		color: FONT_COLOR
	},
	subHeaderTextCharterOnly: {
		fontSize: '14px',
		fontFamily: Bogle_Medium,
		display: 'flex',
		alignItems: 'center',
		color: FONT_COLOR
	},
	dataInUse: {
		fontSize: '16px',
		fontFamily: Bogle_Medium,
		marginTop: 20
	},
	subHeaderCount: {
		position: 'absolute',
		right: 0,
		marginTop: 20,
		fontSize: '16px',
		paddingRight: '16px',
		fontFamily: 'Bogle-Medium',
		color: GREY
	},
	listContainer: {
		padding: 0,
		top: 0,
		marginTop: 20,
		height: 'auto'
	},
	lists: {
		maxHeight: '92%',
		overflowY: 'auto',
		paddingTop: 0,
		paddingBottom: 0
	},
	listItem: {
		height: '40px'
	},
	listItemText: {
		fontSize: '14px !important',
		fontFamily: Bogle_Regular
	},
	listItemTextOneLine: {
		fontSize: '16px',
		fontFamily: Bogle_Regular,
		display: 'inline-block',
		width: '260px'
	},
	listItemRow: {
		marginTop: 0,
		marginBottom: 0
	},
	tooltip: {
		width: '260px',
		marginRight: 32,
		backgroundColor: WHITE,
		border: `1px solid ${LIGHT_GREY}`,
		color: FONT_COLOR,
		pointerEvents: 'auto'
	},
	tooltipPanel: {
		padding: '8px'
	},
	tooltipShowMsg: {
		fontSize: '14px',
		fontFamily: Bogle_Regular,
		width: 260
	},
	tooltipText: {
		fontSize: '16px',
		fontFamily: Bogle_Regular
	},
	filter: {
		color: PURPLE,
		fontFamily: Bogle_Regular,
		fontSize: '16px',
		marginRight: '16px',
		cursor: 'pointer'
	},
	filterBasic: {
		color: FONT_COLOR,
		fontFamily: Bogle_Regular,
		fontSize: '16px',
		marginRight: '16px',
		cursor: 'pointer'
	},
	floatRight: {
		position: 'absolute',
		right: '0px',
		top: '24px'
	},
	moreDataText: {
		color: PURPLE,
		fontSize: '12px'
	},
	lockIcon: {
		width: '16px',
		height: '16px',
		color: PURPLE,
		paddingLeft: '8px',
		paddingTop: '6px'
	},
	subHeaderLockIcon: {
		color: PURPLE,
		height: '14px',
		width: '14px',
		marginLeft: '8px'
	},
	charterOnlyBox: {
		background: TOGGLE_ACTIVE,
		borderRadius: '8px',
		padding: '8px',
		width: '314px',
		marginLeft: '8px',
		paddingBottom: '4px',
		marginBottom: '12px'
	},
	learnMoreBtn: {
		background: PURPLE,
		borderRadius: '16px',
		height: '24px',
		color: WHITE,
		margin: '4px',
		'&:hover': {
			background: `${PURPLE} !important`,
			color: `${WHITE} !important`
		}
	}
}));
export default quickReportStyle;
